module.exports = {
          srcSet: __webpack_public_path__ + "9641737b4be799221a680b0c2ffe2af6-2336.png"+" 2336w",
          images:[ {path: __webpack_public_path__ + "9641737b4be799221a680b0c2ffe2af6-2336.png",width: 2336,height: 420}],
          src: __webpack_public_path__ + "9641737b4be799221a680b0c2ffe2af6-2336.png",
          toString:function(){return __webpack_public_path__ + "9641737b4be799221a680b0c2ffe2af6-2336.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/AE1Z9vxeavf/UF32/jxK9f8iM/j/QULM/2RXnv92aZj+Ylep/0JDyvoAOEb1/D5M9v8vPvX+KTj1/yg49P8jMvP/PEXX/2lqsf40P+L/JTPv+r7VMC5ido1UAAAAAElFTkSuQmCC",
          width: 2336,
          height: 420
        }